module.exports = __webpack_public_path__ + "img/user-o.b8801f30.svg";